import { render, staticRenderFns } from "./GridButton.vue?vue&type=template&id=5bcb2ac7&"
import script from "./GridButton.ts?vue&type=script&lang=js&"
export * from "./GridButton.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports